export default function Logo() {
  return (
    <img
      className="brand-logo"
      src="/images/Header/DLogo.svg"
      alt="Darren"
      width="1943"
      height="510"
    />
  );
}
